<template>
  <input ref="input"
         :type="type"
         :pattern="pattern"
         :value="localValue"
         @input="handleInput"
         :maxlength="maxLength"
         :disabled="isDisabled"
         :readonly="isReadonly"
         :placeholder="placeholder"
         :data-1p-ignore="!allowOnePass"
         class="block text-left w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 sm:text-sm/6 disabled:bg-gray-200 disabled:hover:cursor-not-allowed"/>
</template>

<script setup lang="ts">
import { getMask } from '@/plugins'
import { ref, useTemplateRef, watch } from 'vue'

const localValue = ref<string|null>(null);
const inputRef = useTemplateRef<HTMLInputElement>("input");
const modelValue = defineModel<object|string|number|null>({
  default: null
});

const { type = "text", pattern, isReadonly = false, allowOnePass = false } = defineProps<{
  readonly type?: string;
  readonly pattern?: string;
  readonly maxLength?: number;
  readonly placeholder?: string;
  readonly isReadonly?: boolean;
  readonly isDisabled?: boolean;
  readonly allowOnePass?: boolean;
}>();

function handleInput(event: Event) {
  const value = (event.target as HTMLInputElement).value;

  if (value.length === 0) {
    modelValue.value = null;
    return;
  }

  switch (type) {
    case "number":
      modelValue.value = Number(value);
    break;

    default:
      modelValue.value = value;
    break;
  }
}

watch(modelValue, modelValue => {
  if (!modelValue && modelValue !== 0) {
    localValue.value = null;
    return;
  }

  localValue.value = modelValue.toString();
}, { immediate: true });

watch([inputRef, () => pattern, localValue], ([input, pattern, value], __, onCleanup) => {
  if (!input || !pattern) {
    return;
  }

  const mask = getMask(pattern, input);

  if (value) {
    mask.value = value;
    modelValue.value = mask.value;
  }

  onCleanup(() => mask.destroy());
}, { immediate: true });
</script>